// 中文翻译内容（可按模块划分）
export default {
    nav: {
        home: '首    页',
        product: '产    品',
        contact: '联 系 我 们',
        about: '关 于 我 们'
    },
    // 其他模块的中文翻译（示例）
    common: {
        confirm: '确 认',
        cancel: '取 消',
        home: "首 页"
    },
    product: {
        title: '产品列表',
        price: '价格',
        tirDescription: '我们的{name}采用先进的TIR（全内反射）光学技术，可实现最佳的光线分布。长度为{size}英寸，非常适合紧凑的安装空间，同时能提供强劲的照明效果。该灯条符合SAE J845标准，确保在各种应用场景下的高品质和可靠性。',
        linearDescription: '我们的{name}采用线性光学技术，可提供均匀且远距离的照明。尺寸为{size}英寸，在紧凑设计与强劲性能之间实现平衡，非常适合各类车辆和设备使用。'
    },
    home: {
        category: {
            title: "按类别展示",
            subtitle: "全部分类"
        },
        videoSection: {
            title: "精选视频"
        },
        video: {
            loading: "加载视频中...",
            error: "视频加载失败",
            notSupported: "您的浏览器不支持视频播放"
        },
        productVideos: {
            0: {
                title: "SY-001 孔形 47英寸全尺寸LED灯条",
                description: ""
            },
            1: {
                title: "SY-RT8 孔形遮阳板灯条",
                description: ""
            },
            2: {
                title: "HB-STT8 车载信号灯",
                description: ""
            }
        },
        advantages: {
            advantage1: {
                title: "值得信赖的品质保证",
                detail: "高性能、可靠的ISO认证产品。"
            },
            advantage2: {
                title: "ISO认证产品",
                detail: "经过测试和认证的高性能、高品质车载信号灯。"
            },
            advantage3: {
                title: "现货供应 • 快速配送",
                detail: "在严格把控质量标准的同时，以惊人的速度完成订单。"
            },
            advantage4: {
                title: "高效且稳定",
                detail: "高效的生产流程，及时且有保障的交付。"
            }
        },
        categories: {
            miniLightBars: "迷你灯条",
            fullLightBars: "全尺寸灯条",
            visorLightBars: "遮阳板灯条",
            deckDashLights: "仪表台灯",
            grilleSurfaceMounts: "格栅/表面安装灯",
            siren: "警报器",
            trafficAdvisors: "车载信号灯",
            mountingBrackets: "安装支架"
        },
        videos: {
            trafficAdvisors: "车载信号灯",
            miniLightBars: "迷你灯条",
            companyVideo: "公司介绍"
        }
    },
    products: {
        product2: {
            title: "SY-001 孔形36英寸全尺寸LED灯条",
            description: "高性能全尺寸LED灯条，采用孔形光学技术"
        },
        product9: {
            title: "SY-001 条形36英寸全尺寸LED灯条",
            description: "条形设计36英寸全尺寸LED灯条"
        },
        product3: {
            title: "SY-001 孔形47英寸全尺寸LED灯条",
            description: "47英寸全尺寸LED灯条，配备先进的孔形技术"
        },
        product10: {
            title: "SY-001 条形47英寸全尺寸LED灯条",
            description: "条形光学47英寸全尺寸LED灯条"
        }
    },
    textVideo: {
        title: 'Y-signal公司',
        description: '<p>通过视频您可以更直观地了解我们。</p>',
        features: {
            quality: '卓越的产品质量',
            supplyChain: '完整高效的供应链体系',
            design: '优秀的设计能力',
            experience: '丰富的生产经验'
        },
        buttons: {
            learnMore: '了解更多',
            contactUs: '联系我们'
        }
    },
    lookNow:"查看详情",
    footer: {
        sections: {
            contactInfo: "联系信息",
            products: "产品",
            company: "公司"
        },
        contactInfo: {
            workTime: "周一至周六",
            email: "Marketing@@y-signal.com",
            phone: "0577-85220619",
            address: "浙江省温州市金海二道466号",
            webUrl: "www.y-signal.com"
        },
        company: {
            aboutUs: "关于我们",
            contactUs: "联系我们",
            productCatalog: "产品目录"
        },
        copyright: "版权所有 © Y-signal. 保留所有权利"
    },
    // 产品分类（与其他组件共用）
    categories: {
        miniLightBars: "迷你灯条",
        fullLightBars: "全尺寸灯条",
        visorLightBars: "遮阳板灯条",
        deckDashLights: "仪表台灯",
        grilleSurfaceMounts: "格栅/表面安装灯",
        siren: "警报器",
        trafficAdvisors: "车载信号灯",
        mountingBrackets: "安装支架"
    },
    productList: {
        selectCategory: "选择分类"
    },
    productCategories: {
        allProducts: "所有产品",
        allProductsDesc: "浏览我们的所有产品",
        miniLightBarsDesc: "我们的迷你灯条尺寸为18-27英寸，安装方便，占用空间小。",
        fullLightBarsDesc: "全尺寸灯条，提供最大可见度",
        visorLightBarsDesc: "可安装在车辆遮阳板上，使用隐蔽",
        deckDashLightsDesc: "紧凑型灯，适用于仪表板或平台安装",
        grilleSurfaceMountsDesc: "格栅和表面安装照明解决方案",
        sirenDesc: "用于信号车辆的高品质警报器",
        trafficAdvisorsDesc: "交通指挥和安全照明"
    },
    productSeries: {
        tirSeries: "孔形" +
            "" +
            "系列",
        linearSeries: "条形系列",
        switchBoxes: "开关盒",
        sy001Tir: "SY-001 孔形",
        sy001Linear: "SY-001 条形",
        sy002Tir: "SY-002 孔形",
        mountingBrackets: "安装支架"
    },
    productNames: {
        miniLedLightBar: "{series} {size}英寸 迷你LED灯条",
        fullSizeLedLightBar: "{series} {size}英寸 全尺寸LED灯条",
        g003LinearGrilleLight: "G003 条形格栅灯",
        g004LinearGrilleLight: "G004 条形格栅灯",
        g006LinearGrilleLight: "G006 条形格栅灯",
        g003TirGrilleLight: "G003 TIR格栅灯",
        g004TirGrilleLight: "G004 TIR格栅灯",
        g006TirGrilleLight: "G006 TIR格栅灯",
        hbStt1: "HB-STT1",
        hbStt2: "HB-STT2",
        hbStt4: "HB-STT4",
        hbStt6: "HB-STT6",
        hbStt8: "HB-STT8",
        syRt8VisorLightBar: "SY-RT8 遮阳板灯条",
        syRt10VisorLightBar: "SY-RT10 遮阳板灯条",
        hSa100: "HS-A150",
        hSb200: "HS-B200",
        hSm100: "HS-M100",
        hPa100: "HP-A100",
        hSv100: "HS-V100",
        qAdhb: "HQ-122",
        qDstvb: "HQ-111",
        qHmb: "HQ-HMB",
        qSstb: "HQ-110",
        qSthb: "HQ-121",
        qLpb: "HQ-120",
        qRve: "HQ-RVE"
    },
    allFeatures: {
        "T18": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共60个3瓦LED灯珠",
            "34种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为11英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V",
            "最大电流3.4安培"
        ],
        "L18": [
            "符合SAE J845标准",
            "光学技术 - 线性光学系统",
            "共120个3瓦LED灯珠",
            "44种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为11英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V",
            "最大电流4.7安培"
        ],
        "T27": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共84个3瓦LED灯珠",
            "34种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为12英尺",
            "从连接器延伸的电源线长度为12.5英尺",
            "从连接器延伸的辅助线长度为12.5英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V"
        ],
        "L27": [
            "符合SAE J845标准",
            "光学技术 - 线性光学系统",
            "共168个3瓦LED灯珠",
            "44种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为12英尺",
            "从连接器延伸的电源线长度为12.5英尺",
            "从连接器延伸的辅助线长度为12.5英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V"
        ],
        "T36": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共108个3瓦LED灯珠",
            "34种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为12英尺",
            "从连接器延伸的电源线长度为12.5英尺",
            "从连接器延伸的辅助线长度为12.5英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V"
        ],
        "L36": [
            "符合SAE J845标准",
            "光学技术 - 线性光学系统",
            "共216个3瓦LED灯珠",
            "44种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为12英尺",
            "从连接器延伸的电源线长度为12.5英尺",
            "从连接器延伸的辅助线长度为12.5英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V"
        ],
        "T47": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共132个3瓦LED灯珠",
            "34种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为12英尺",
            "从连接器延伸的电源线长度为12.5英尺",
            "从连接器延伸的辅助线长度为12.5英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V"
        ],
        "L47": [
            "符合SAE J845标准",
            "光学技术 - 线性光学系统",
            "共264个3瓦LED灯珠",
            "44种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为12英尺",
            "从连接器延伸的电源线长度为12.5英尺",
            "从连接器延伸的辅助线长度为12.5英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V"
        ],
        "T55": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共156个3瓦LED灯珠",
            "34种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为12英尺",
            "从连接器延伸的电源线长度为12.5英尺",
            "从连接器延伸的辅助线长度为12.5英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V"
        ],
        "L55": [
            "符合SAE J845标准",
            "光学技术 - 线性光学系统",
            "共312个3瓦LED灯珠",
            "44种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为12英尺",
            "从连接器延伸的电源线长度为12.5英尺",
            "从连接器延伸的辅助线长度为12.5英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V"
        ],
        "T63": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共180个3瓦LED灯珠",
            "34种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为12英尺",
            "从连接器延伸的电源线长度为12.5英尺",
            "从连接器延伸的辅助线长度为12.5英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V"
        ],
        "L63": [
            "符合SAE J845标准",
            "光学技术 - 线性光学系统",
            "共360个3瓦LED灯珠",
            "44种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为12英尺",
            "从连接器延伸的电源线长度为12.5英尺",
            "从连接器延伸的辅助线长度为12.5英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V"
        ],
        "T71": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共204个3瓦LED灯珠",
            "34种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为12英尺",
            "从连接器延伸的电源线长度为12.5英尺",
            "从连接器延伸的辅助线长度为12.5英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V"
        ],
        "L71": [
            "符合SAE J845标准",
            "光学技术 - 线性光学系统",
            "共408个3瓦LED灯珠",
            "44种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为12英尺",
            "从连接器延伸的电源线长度为12.5英尺",
            "从连接器延伸的辅助线长度为12.5英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V"
        ],
        "GD1": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共40个3瓦LED灯珠",
            "30种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为11英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V",
            "最大电流3.4安培"
        ],
        "GD2": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共40个3瓦LED灯珠",
            "30种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为11英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V",
            "最大电流3.4安培"
        ],
        "GD4": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共40个3瓦LED灯珠",
            "30种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为11英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V",
            "最大电流3.4安培"
        ],
        "GD6": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共40个3瓦LED灯珠",
            "30种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为11英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V",
            "最大电流3.4安培"
        ],
        "GD8": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共40个3瓦LED灯珠",
            "30种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为11英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V",
            "最大电流3.4安培"
        ],
        "ZT3": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共40个3瓦LED灯珠",
            "30种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为11英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V",
            "最大电流3.4安培"
        ],
        "ZT4": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共40个3瓦LED灯珠",
            "30种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为11英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V",
            "最大电流3.4安培"
        ],
        "ZT6": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "共40个3瓦LED灯珠",
            "30种闪光模式",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "带开关和闪光模式切换的点烟器插头需单独购买",
            "从灯条到连接器的线缆长度为11英尺",
            "防水外壳",
            "包含磁性安装支架",
            "工作电压11V-14V",
            "最大电流3.4安培"
        ],
        "ZL3": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "3个3瓦LED灯珠",
            "内置同步和交替同步功能",
            "24种可选独立闪光模式",
            "3种交替同步模式速度",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "包含1英尺线缆",
            "防水外壳",
            "工作电压11V-14V",
            "最大电流290毫安"
        ],
        "ZL4": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "4个3瓦LED灯珠",
            "内置同步和交替同步功能",
            "34种可选独立闪光模式",
            "3种交替同步模式速度",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "包含1英尺线缆",
            "防水外壳",
            "工作电压11V-14V",
            "最大电流570毫安"
        ],
        "ZL6": [
            "符合SAE J845标准",
            "光学技术 - TIR光学系统",
            "6个3瓦LED灯珠",
            "内置同步和交替同步功能",
            "34种可选独立闪光模式",
            "3种交替同步模式速度",
            "非易失性存储器可记忆最后使用的闪光模式",
            "使用寿命长达100,000小时",
            "包含1英尺线缆",
            "防水外壳",
            "工作电压11V-14V",
            "最大电流570毫安"
        ]
    },
    T18DES: "SY-001 18英寸TIR LED车载信号灯条配备120个3瓦LED灯珠，这款18英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的34种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制。\n",
    T27DES: "SY-001 27英寸TIR LED车载信号灯条配备168个3瓦LED灯珠，这款27英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的34种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制。\n",
    T36DES: "SY-001 36英寸TIR LED车载信号灯条配备216个3瓦LED灯珠，这款36英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的34种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制\n",
    T47DES: "SY-001 47英寸TIR LED车载信号灯条配备264个3瓦LED灯珠，这款47英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的34种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制。\n",
    T55DES: "SY-001 55英寸TIR LED车载信号灯条配备312个3瓦LED灯珠，这款55英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的34种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制。\n",
    T63DES: "SY-001 63英寸TIR LED车载信号灯条配备360个3瓦LED灯珠，这款18英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的34种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制。\n",
    T71DES: "SY-001 71英寸TIR LED车载信号灯条配备408个3瓦LED灯珠，这款18英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的34种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制。\n",
    L18DES: "SY-001 18英寸线性LED车载信号灯条配备120个3瓦LED灯珠，这款18英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的44种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制\n",
    L27DES: "SY-001 27英寸线性LED车载信号灯条配备168个3瓦LED灯珠，这款18英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的44种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制\n",
    L36DES: "SY-001 36英寸线性LED车载信号灯条配备216个3瓦LED灯珠，这款18英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的44种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制\n",
    L47DES: "SY-001 47英寸线性LED车载信号灯条配备264个3瓦LED灯珠，这款18英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的44种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制\n",
    L55DES: "SY-001 55英寸线性LED车载信号灯条配备312个3瓦LED灯珠，这款18英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的44种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制\n",
    L63DES: "SY-001 63英寸线性LED车载信号灯条配备360个3瓦LED灯珠，这款18英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的44种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制\n",
    L71DES: "SY-001 71英寸线性LED车载信号灯条配备408个3瓦LED灯珠，这款18英寸信号灯条将创新的LED技术与聚碳酸酯、阳极氧化铝混合外壳完美结合。在信号照明领域，可靠性至关重要。因此，我们始终致力于通过SAE J845认证、2年保修以及提供市场上最高质量、最实惠的产品来建立信任。IP 68防护等级，全密封设计，防潮湿、防振动、防腐蚀。配备6个LED琥珀色箭头灯（可升级为多色），非易失性存储器可锁定您喜爱的44种闪光模式之一，并有通用或车型专用 gutter安装支架可供选择，可根据您的特殊要求进行定制\n",
    TGD: "坚固、防腐、防水的铝制外壳具有出色的散热性能\n" +
        "提供双色或三色选择\n" +
        "长度灵活，适用于不同车辆的内部或外部使用\n" +
        "易于安装，可采用螺丝或支架固定\n" +
        "可根据您的特殊要求进行定制。",
    TZD: "每个单元有透明、绿色或琥珀色可供选择，并具有多种独特的闪光模式。具备警示和工作照明功能 喷涂铝材质• PC透镜，抗紫外线 两种灵活的支架，适合安装在汽车格栅、保险杠和引擎盖上 IP 68防护等级；全密封设计，防潮湿、防振动、防腐蚀。\n",
    ZJ: "安装支架为将车载信号灯安全安装到您的车辆上提供必要的支撑。从我们的通用和车型专用安装支架中选择，使您的产品安装快速简便。",
    ZYB: "最受欢迎的车载信号灯解决方案之一是室内LED遮阳板灯条。这些灯具有多样化的配置和多功能性，非常适合多种车辆照明需求。无论您需要为您的车辆提供隐蔽式还是低调的照明，我们的室内挡风玻璃遮阳板灯都能提供完美的解决方案。\n" +
        "采用高性能3瓦LED技术，封装在紧凑、流线型的设计中，我们经济实惠的LED遮阳板灯条系列有望超越您的期望。每个单元都将强大的亮度与低调的美学相结合，使其成为安全、能见度或特殊车辆设置的重要补充。",
    currentDes: "",
    JBQ: "在信号领域，响笛是急救人员和信号车辆必不可少的资产。当时间和安全至关重要时，响亮、高输出的响笛对于确立道路主导权至关重要。",
    mini:"迷你LED灯条",
    full:"全尺寸LED灯条",
    techSpecs: {
        length: "尺寸",
        opticTechnology: "光学技术",
        ledQuantity: "LED数量",
        flashPatterns: "闪烁模式",
        powerSupply: "电源供应",
        lifespan: "使用寿命",
        weatherResistance: "耐候性",
        mounting: "安装方式",
        // 具体值的翻译
        powerValue: "11V-14V",
        lifespanValue: "长达100,000小时",
        weatherValue: "防水外壳",
        mountingValue: "含磁性支架",
        tirOptics: "TIR光学",
        linearOptics: "线性光学"
    },
    flashPatterns: {
        tSeries: "共34种闪烁模式",  // T系列闪烁模式
        lSeries: "共44种闪烁模式",   // L系列闪烁模式
        zlSeries24: "共24种闪烁模式",   // L系列闪烁模式
        zlSeries22: "共22种闪烁模式" ,  // L系列闪烁模式
        zlSeries26: "共26种闪烁模式" ,  // L系列闪烁模式
    },
    ledQuantity: {
        3: "3个3瓦LED",
        4: "4个3瓦LED",
        6: "6个3瓦LED",
        8: "8个3瓦LED",
        12: "12个3瓦LED",
        24: "24个3瓦LED",
        36: "36个3瓦LED",
        48: "48个3瓦LED",
        60: "60个3瓦LED",
        84: "84个3瓦LED",
        108: "108个3瓦LED",
        132: "132个3瓦LED",
        156: "156个3瓦LED",
        180: "180个3瓦LED",
        204: "204个3瓦LED",
        120: "120个3瓦LED",
        168: "168个3瓦LED",
        216: "216个3瓦LED",
        264: "264个3瓦LED",
        312: "312个3瓦LED",
        360: "360个3瓦LED",
        408: "408个3瓦LED",
        na: "无数据"
    },
    optic:{
        tir: "TIR光学",       // T系列光学技术
        linear: "线性光学"    // L系列光学技术
    },
    applicationScenarios: {
        emergency: "信号车辆",
        lawEnforcement: "常见车辆",
        construction: "工程设备和机械",
        offRoad: "越野车和卡车",
        marine: "船舶和游艇",
        industrial: "工业和商用车辆"
    },
    noRelated: "该产品暂无相关配件。",
    zapplicationScenarios: {
        // 新增场景翻译
        grilleMounting: "车辆格栅安装",
        emergencySignaling: "信号车辆信号",
        industrialIndication: "工业设备指示"
    },
    gapplicationScenarios: {
        // 新增场景翻译
        grilleMounting:  "仪表台 / 仪表盘安装",
        emergencySignaling: "信号车辆信号",
        industrialIndication: "工业设备指示"
    },
    tapplicationScenarios: {
        // 新增场景翻译
        grilleMounting:  "交通引导",
        emergencySignaling: "信号车辆信号",
        industrialIndication: "工业设备指示"
    },
    grilleLight: "这款格栅灯专为表面安装设计，具有紧凑的尺寸和强劲的照明效果。",
    strikerLight: "1英寸 striker灯，采用TIR光学技术，非常适合紧凑空间的信号需求。",
    strikerLight2: "2英寸 striker灯，采用TIR光学技术，非常适合紧凑空间的信号需求。",
    strikerLight4: "4英寸 striker灯，采用TIR光学技术，非常适合紧凑空间的信号需求。",
    strikerLight6: "6英寸 striker灯，采用TIR光学技术，非常适合紧凑空间的信号需求。",
    strikerLight8: "6英寸 striker灯，采用TIR光学技术，非常适合紧凑空间的信号需求。",
    sirenSpecs: {
        // 规格名称
        controllerDimensions: "控制器尺寸",
        amplifierDimensions: "放大器尺寸",
        powerOutput: "功率输出",
        paHornFunctions: "公共广播&喇叭音调功能：",
        tonesInclude: "包含音调：",
        siren: "响笛：",
        horn: "喇叭：",
        // 规格值（保留英寸单位，补充中文说明）
        controllerSize: "5.75\"长x3.25\"高x1.4\"宽",
        amplifierSize: "8.5\"长x2.75\"高x5.75\"宽",
        powerOutputValue: "200瓦放大器输出（适用于2个100瓦扬声器）",
        // 功能列表
        function1: "可编程手动模式",
        function2: "无线电转播功能",
        function3: "6个辅助开关，每个额定10安培",
        function4: "可作为200瓦\"双音\"响笛（配2个扬声器）或100瓦单音响笛（配1个扬声器）。\"双音\"功能支持每个扬声器输出独立的响笛音调",
        function5: "含麦克风",
        // 音调列表（保留专业术语英文，便于识别）
        sirenTones: "Wail（长鸣）, Yelp（急鸣）, Sting（锐鸣）, Mech（机械音）, Tool（工具音）, Hi-Lo（高低音）",
        hornTones: "High（高音）, Low（低音）"
    },
    siren: {
        // 参数名称
        controllerDimensions: "控制器尺寸",
        amplifierDimensions: "放大器尺寸",
        powerOutput: "功率输出",
        paHornFunctions: "公共广播&喇叭音调功能：",
        tonesInclude: "包含音调：",
        siren: "响笛：",
        horn: "喇叭：",

        // 参数值（保留英寸单位，补充中文说明）
        controllerSize: "5.75\"长x3.25\"高x1.4\"宽",
        amplifierSize: "8.5\"长x2.75\"高x5.75\"宽",
        powerOutputValue: "200瓦放大器输出（适用于2个100瓦扬声器）",

        // 功能列表
        func1: "可编程手动模式",
        func2: "无线电转播功能",
        func3: "6个辅助开关，每个额定10安培",
        func4: "可作为200瓦“双音”响笛（配2个扬声器）或100瓦单音响笛（配1个扬声器）。“双音”功能支持每个扬声器输出独立的响笛音调",
        func5: "含麦克风",

        // 音调列表（保留英文术语+中文注释）
        sirenTones: "Wail（长鸣）、Yelp（急鸣）、Sting（锐鸣）、Mech（机械音）、Tool（工具音）、Hi-Lo（高低音）",
        hornTones: "High（高音）、Low（低音）"
    },
    smallSiren: {
        // 规格名称
        amplifierDimensions: "放大器尺寸",
        powerOutput: "功率输出",
        paWarningFunctions: "公共广播&警示音调功能：",
        tonesInclude: "包含音调：",
        siren: "响笛：",
        horn: "喇叭：",

        // 规格值（补充中文维度说明）
        amplifierSize: "5.5\"长x1.75\"高x3.25\"宽",
        powerOutputValue: "100瓦放大器输出",
        combinedUnit: "放大器与控制器一体化单元",

        // 功能与音调（保留术语+注释）
        func1: "含麦克风",
        sirenTones: "Wail（长鸣）、Yelp（急鸣）、Sting（锐鸣）、Mech（机械音）、Tool（工具音）、Hi-Lo（高低音）",
        hornTones: "High（高音）、Low（低音）"
    },
    controllerSiren: {
        // 规格名称
        controllerDimensions: "CONTROLLER DIMENSIONS",
        amplifierDimensions: "AMPLIFIER DIMENSIONS",
        powerOutput: "POWER OUTPUT",
        paHornFunctions: "PA&horn tone functions:",
        tonesInclude: "Tones include:",
        siren: "Siren:",
        horn: "Horn:",

        // 规格值
        controllerSize: "2.5\"Lx4.9\"Hx0.8\"D", // 修正原数据中的".8"为"0.8"
        amplifierSize: "8.5\"Lx2.75\"Hx5.75\"D", // 修正原数据中的".5.75"为"5.75"
        powerOutputValue: "100-Watt amplifier output",

        // 功能列表
        func1: "Programmable manual mode",
        func2: "Radio rebroadcast function",
        func3: "6 auxiliary switches rated for 10amps each",
        func4: "Handheld controller with built in microphone",

        // 音调列表
        sirenTones: "Wail,Yelp,Sting,Mech,Tool,Hi-Lo",
        hornTones: "High,Low"
    },
    sirenSpecsV2: {
// 规格名称
        controllerDimensions: "控制器尺寸",
        amplifierDimensions: "放大器尺寸",
        powerOutput: "功率输出",
        paHornFunctions: "公共广播 & 喇叭音调功能：",
        tonesInclude: "包含音调：",
        siren: "响笛：",
        horn: "喇叭：",
// 规格值（补充维度说明）
        controllerSize: "5.75\" 长 x3.25\"高 x1.4\" 宽 ",
        amplifierSize: "8.5\" 长 x2.75\"高 x5.75\" 宽 ",
        powerOutputValue: "100 瓦放大器输出",
// 功能列表
        func1: "可编程手动模式",
        func2: "无线电转播功能",
        func3: "6 个辅助开关，每个额定 10 安培",
        func4: "带内置麦克风的手持控制器",
// 音调列表（保留术语 + 注释）
        sirenTones: "Wail（长鸣）、Yelp（急鸣）、Sting（锐鸣）、Mech（机械音）、Tool（工具音）、Hi-Lo（高低音）",
        hornTones: "High（高音）、Low（低音）"
    },
    zjapplicationScenarios: {
        // 新增场景翻译
        grilleMounting:  "车辆格栅安装",
        emergencySignaling:  "信号车辆信号装置",
    },
    pageTitles: {
        productDetails: "产品详情", // 对应 Product Details
        basicInformation: "基本信息", // 对应 Basic Information
        technicalSpecifications: "技术规格", // 对应 Technical Specifications
        parameterValue: "参数" ,
        value: "值", // 对应 Parameter Value
        applicationScenarios: "应用场景", // 对应 Application Scenarios
        goInquire:"询盘",
        relatedAccessories:"相关配件",
        patentNumber:"专利号",
        size:"尺寸"
    },
    contact: {
        title: "联 系 信 息",
        // 社交媒体平台名称
        facebook: "Facebook",
        instagram: "Instagram",
        productInquiryTitle: "产品询盘",

        // 表单标签（使用全角标点，符合中文习惯）
        formLabels: {
            name: "姓名：",
            email: "邮箱：",
            phone: "电话：",
            product: "感兴趣产品：",
            quantity: "数量：",
            message: "留言："
        },

        // 按钮 & 提示（简洁易懂）
        submitBtnText: "提交询盘",
        successMsg: "感谢您的询盘！我们将尽快与您联系。"
    },
    about: {
        // 页面核心文本
        title: "关于我们 Y-signal",
        biaoyu: "我们坚信，专注让我们更专业。",
        sectionTitle: "企业概况", // 统计区顶部标题
        imgAlt: "公司形象", // 图片alt属性

        // 统计卡片描述
        stats: {
            professionalStaff: "专业员工",
            patents: "专利技术",
            foundedYear: "成立年份"
        },

        // 内容区块标题
        blocks: {
            companyOverview: "公司简介",
            productAdvantages: "产品优势",
            serviceIdea: "服务理念"
        },

        // 公司介绍详情（优化中文流畅性）
        des_a: "温州商宇科技有限公司成立于2018年，是一家集研发、生产、销售于一体的综合性科技企业，也是中国车载信号灯行业的主要制造商之一。目前，公司拥有40余名员工，持有90余项专利及1项著作权。\n我们专注于为工业丶信号等多个领域提供高亮度、高可靠性的警示照明解决方案。我们深知，在复杂多变的环境中，清晰的警示信号对保障人员安全、引导有序行动至关重要。",
        des_b: "公司产品线丰富，涵盖全尺寸车载信号灯条、迷你车载信号灯条、遮阳板车载信号灯条、警报器及扬声器等。产品采用先进的光学设计与材料技术，确保在远距离、恶劣天气下仍具备清晰的可视性；凭借优异的防水防尘性能、低能耗及长使用寿命，赢得了全球客户的信赖。",
        des_c: "我们注重技术创新与质量管控，拥有专业的研发团队及严格的生产管理体系，确保每一款产品均达到行业最高标准。同时，我们提供定制化服务，以满足不同场景的特殊需求。"
    }
    // ... 更多模块
};
